import { Link } from "react-router-dom";
import { SITE_NAME, SITE_SLOGAN } from "@/mocks/fancha";

interface FanchaLogoProps {
  compact?: boolean;
}

export default function FanchaLogo({ compact = false }: FanchaLogoProps) {
  return (
    <Link to="/" className="group inline-flex items-center gap-2.5 whitespace-nowrap">
      {/* 双色反差标识 */}
      <span className="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-foreground-950 ring-1 ring-background-200">
        <span className="absolute inset-y-0 left-0 w-1/2 bg-primary-500" aria-hidden="true" />
        <span className="absolute inset-y-0 right-0 w-1/2 bg-accent-400" aria-hidden="true" />
        <span className="relative z-10 font-heading text-lg font-black text-background-50" aria-hidden="true">
          反
        </span>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
          {SITE_NAME}
        </span>
        {!compact && (
          <span className="mt-0.5 hidden text-[11px] text-foreground-500 sm:block">{SITE_SLOGAN}</span>
        )}
      </span>
    </Link>
  );
}